import { activeProfileView } from './activeProfileMode';
import { setUserData as cacheUserData } from '../DataCache/userData';
import { setProfileIdentity as cacheProfileIdentity } from '../DataCache/profileIdentity';
import { setStoredActiveProfileMode } from './activeProfileMode';

/**
 * Map /api/profile JSON into the posts shell profile object.
 * Returns null when no userProfile is present.
 */
export function applySessionProfileFromApi(data) {
  if (!data?.userProfile) return null;
  const up = data.userProfile;
  const identity = data.profileIdentity || null;
  const activeView = activeProfileView(up, identity);
  cacheUserData(up);
  cacheProfileIdentity(identity);
  if (identity?.activeProfileMode) {
    setStoredActiveProfileMode(identity.activeProfileMode);
  }
  return {
    superAdmin: data.superAdmin === true,
    userId: up?.userId,
    tenantId: up?.tenantId || '',
    tenantName: up?.tenantName || '',
    email: up?.email,
    name: activeView.displayName || [up.first_name, up.last_name].filter(Boolean).join(' '),
    profilePictureUrl: activeView.profilePictureUrl || '',
    profileMode: activeView.mode || 'personal',
    emailNotVerified: data.emailNotVerified === true,
  };
}
